export default "__VITE_ASSET__D5Jg8dlo__"